var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout__content"},[_c('Header',{attrs:{"title":"Jowett.me","show-burger":true}}),_c('section',{staticClass:"page page__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }